export default class EitherOrStats {
  public participationCount: number = null;
}
